import { useState, useEffect } from 'react';

export const useElementObserver = ({
  observedId,
  rootMarginInPixel,
}: {
  observedId: string;
  rootMarginInPixel?: string;
}) => {
  const [isVisibleInViewport, setVisibleInViewport] = useState(false);

  useEffect(() => {
    const element = document.querySelector(`#${observedId}`);
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          setVisibleInViewport(entry.isIntersecting);
        });
      },
      { rootMargin: rootMarginInPixel || '0px' },
    );
    element && observer.observe(element);

    return () => {
      observer.disconnect();
    };
  }, []);

  return {
    isVisibleInViewport,
  };
};
